<template>
  <div class="ruoli-completati">
    <span
      v-for="ruolo in ruoli_array"
      :key="ruolo"
      class="onlyLetter"
      :class="ruoliClasses(ruolo, id_squadra)"
    >
      {{ acquistiPerRuolo(ruolo, id_squadra) }}
    </span>
  </div>
</template>

<script>
import mixins from "../../js/mixins";

export default {
  name: "ruoli-completati",
  mixins: [mixins],
  props: {
    id_squadra: {
      type: [Number, String],
      required: true,
      default: null,
    },
  },
  methods: {
    ruoliClasses(ruolo, id_squadra) {
      return {
        ["Ruolo Ruolo_" + ruolo]: true,
        "text--disabled": this.acquistiCompletati(ruolo, id_squadra),
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.Ruolo {
  min-width: 10px !important;
  width: 10px !important;
}
      .ruoli-completati {
    text-align: center;
    font-weight: 900;
      }
</style>
